import { IcecastServerError } from './errors.js';
import { parseBasicAuthHeaders } from './utils.js';
class HttpClient {
    constructor(host, admin) {
        (this.host = host, this.admin = admin);
    }
    checkHost() {
        if (!this.host) {
            throw new IcecastServerError('Host is missing.');
        }
    }
    async makeRequest(endpoint, options) {
        const { params, body } = options ?? {};
        this.checkHost();
        const baseUrl = this.host;
        const apiUrl = baseUrl + endpoint.path + (params ? `?${new URLSearchParams(params)}` : '');
        const authenticate = endpoint.auth;
        const headers = {
            ...(authenticate && { ...parseBasicAuthHeaders(this.admin.username, this.admin.password) }),
        };
        try {
            const response = await fetch(apiUrl, {
                headers,
                method: endpoint.method,
                ...(body && { body: JSON.stringify(body) }),
            });
            if (!response.ok) {
                throw new IcecastServerError(response.statusText);
            }
            else {
                return endpoint?.xml
                    ? {
                        status: response.status,
                        message: await response.text(),
                    }
                    : await response.json();
            }
        }
        catch (error) {
            throw new IcecastServerError(error?.cause?.message ?? error?.message);
        }
    }
}
export default HttpClient;
